import React from 'react'
import Navbar from '../Navbar/Navbar'

const Header = () => {
  return (
    <div>
      <Navbar isInHeader = {true}/>
    </div>
  )
}

export default Header